import Api from '@/axios'

export default {
  getFaqList (filter) {
      return Api().get('admin-faq', {
      params: filter
    })
  },
  filterNotification () {
    return Api().get('all-notifications')
  }
}
